import { news } from '@/mocks/dramas';

const tagStyle: Record<string, string> = {
  剧情速递: 'bg-[#e85d3f] text-white',
  吃瓜热议: 'bg-[#3e7c59] text-white',
  抢先看: 'bg-[#8a6d3b] text-white',
  剧集安利: 'bg-[#b0883a] text-white',
};

export default function News() {
  return (
    <section id="news" className="scroll-mt-20 bg-[#faf6ef] py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-[1fr_360px]">
          <div>
            <div className="mb-6 flex flex-col gap-1">
              <p className="text-xs font-bold uppercase tracking-widest text-[#e85d3f]">每集都有新瓜落地</p>
              <h2 className="font-serif-sc text-2xl font-black text-[#26201a] md:text-3xl">剧情速递 · 吃瓜第一现场</h2>
            </div>

            <div className="space-y-5">
              {news.map((n) => (
                <article
                  key={n.title}
                  className="group overflow-hidden rounded-2xl border border-[#26201a]/8 bg-white md:flex"
                >
                  <div className="relative h-44 shrink-0 overflow-hidden md:h-auto md:w-[38%]">
                    <img
                      src={n.img}
                      alt={n.title}
                      className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                    />
                  </div>
                  <div className="flex flex-1 flex-col p-5 md:p-6">
                    <div className="mb-3 flex flex-wrap items-center gap-2">
                      <span className={`rounded-full px-2.5 py-1 text-[10px] font-bold ${tagStyle[n.tag]}`}>{n.tag}</span>
                      <span className="text-xs text-[#a3988a]">
                        <i className="ri-time-line mr-1"></i>
                        {n.date}
                      </span>
                    </div>
                    <h3 className="mb-2 font-serif-sc text-base font-black leading-snug text-[#26201a] transition-colors group-hover:text-[#e85d3f] md:text-lg">
                      {n.title}
                    </h3>
                    <p className="line-clamp-2 text-xs leading-6 text-[#6f655a] md:text-sm">{n.excerpt}</p>
                  </div>
                </article>
              ))}
            </div>
          </div>

          <aside>
            <div className="sticky top-20 rounded-2xl border border-[#26201a]/8 bg-white p-5">
              <div className="mb-5 flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#e85d3f]/10 text-[#e85d3f]">
                  <i className="ri-news-line"></i>
                </span>
                <div>
                  <p className="font-serif-sc text-base font-black text-[#26201a]">追更速报</p>
                  <p className="text-[11px] text-[#a3988a]">每日一更 · 追更不迷路</p>
                </div>
              </div>
              <p className="mb-4 rounded-xl bg-[#f3ecdf]/60 p-4 text-xs leading-6 text-[#6f655a]">
                打开微信或常驻本站，第一时间掌握今晚最新剧情与更新动态。别让热剧的高光时刻从你指缝间溜走。
              </p>
              <a
                href="#subscribe"
                className="flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-[#e85d3f] px-4 py-3 text-sm font-semibold text-white hover:bg-[#c9431f]"
              >
                <i className="ri-send-plane-line"></i> 订阅每日追更速报
              </a>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}